import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  CUSTOMER_SHOW_ERROR,
  CUSTOMER_SHOW_LOADING,
  CUSTOMER_SHOW_RETRIEVED_SUCCESS,
  CUSTOMER_SHOW_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  retrieved: null
};

function error(error) {
  return {type: CUSTOMER_SHOW_ERROR, error};
}

function loading(loading) {
  return {type: CUSTOMER_SHOW_LOADING, loading};
}

function retrieved(retrieved) {
  return {type: CUSTOMER_SHOW_RETRIEVED_SUCCESS, retrieved};
}

function reset() {
  return {type: CUSTOMER_SHOW_RESET};
}

const getters = {
  error: state => state.error,
  loading: state => state.loading,
  item: state => state.retrieved
};

const actions = {
  retrieve({ commit }, id) {
    commit(loading(true));
    commit(error(null));
    return http.fetch('/customers/'+id)
      .then(response => response.json())
      .then(data => {
        commit(loading(false));
        commit(retrieved(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [CUSTOMER_SHOW_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [CUSTOMER_SHOW_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [CUSTOMER_SHOW_RETRIEVED_SUCCESS] (state, payload) {
      state.retrieved = payload.retrieved;
    },
    [CUSTOMER_SHOW_RESET] (state) {
      state.retrieved = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customer/show.js